<template>
<div class="chapter">
<div class="inner_page">
<div class="centerImage1"><svg:svg height="100%" viewbox="0 0 1200 1600" width="100%"><svg:image height="1600" transform="translate(0 0)" width="1200" xlink:href="Images/Cover.jpg"></svg:image></svg:svg></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// mysoultotake_cov.vue?c52a93bc